/**
 * 目次開閉
 */
import $ from 'jquery'

const $title = $('.js-post-index__title');
const $index = $('.js-post-index__list');
const active = 'is-active';

// ロード時はアクティブ
$title.addClass(active);

$title.click(function() {
  if ($index.is(':animated')) {
    $index.stop();
  }
  if ($title.hasClass(active)) {
    $title.removeClass(active);
    $index.slideUp();
  } else {
    $title.addClass(active);
    $index.slideDown();
  }
});
